var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-box",style:('background-color: ' + _vm.color)},[_c('p',[_vm._v(_vm._s((_vm.number).toLocaleString('pt-BR')))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }